import React, { useEffect, useState } from "react";
import {
  Card,
  Stack,
  Container,
  Typography,
  Tooltip,
  IconButton,
  CircularProgress
} from "@mui/material";
import { DeleteSharp, EditSharp } from "@mui/icons-material";
import Page from "src/components/Page";
import {
  deleteLvbsessionPodcast,
  insertLvbsessionPodcast,
  updateLvbsessionPodcast
} from "src/api/commonapi";
import { notification } from "src/utils/messages";
import { fetchLvbsessionPodcastList } from "src/utils/common";
import DataTable from "react-data-table-component";
import Select from "react-select";
import { TextField, Button, Grid, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import Deletemodal from "./DeleteModal";
import Label from "src/components/Label";
import { CSVLink } from "react-csv";
import CustomLoader from "src/components/CustomLoader";

//---------------------------------------------------------

export default function LvbSessionPodcast() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const [getdata, setgetdata] = useState({
    l_type: 0,
    l_p_title: "",
    l_p_url: ""
  });
  const [step, setStep] = useState(0);
  const [lvbsessionPodcastList, setLvbsessionPodcastList] = useState([]);
  const [sessionPodcastData, setNewSessionPodcastData] = useState([]);
  const [response, setresponse] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });

  const LVBtypeOptions = [
    { label: "All", value: 0 },
    { label: "LVB Session", value: 1 },
    { label: "LVB Podcast", value: 2 }
  ];

  const [searchData, setSearchData] = useState({
    lvbStatus: 0,
    search: ""
  });

  const ClearSearchResult = async () => {
    setSearchData({
      lvbStatus: 0,
      search: ""
    });
  };

  useEffect(() => {
    filterData();
  }, [searchData, lvbsessionPodcastList]);

  const filterData = () => {
    const RequestList =
      lvbsessionPodcastList &&
      lvbsessionPodcastList.filter((req) => {
        if (
          (searchData.lvbStatus == 0
            ? [1, 2].includes(req.l_type)
            : req.l_type === searchData.lvbStatus) &&
          (req.l_p_title.toLowerCase().includes(searchData?.search.toLowerCase()) ||
            req.l_p_url.toLowerCase().includes(searchData?.search.toLowerCase()))
        ) {
          return req;
        }
      });
    setNewSessionPodcastData(RequestList);
  };

  useEffect(async () => {
    setLoading(true);
    setLvbsessionPodcastList(await fetchLvbsessionPodcastList());
    setLoading(false);
  }, [response]);

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row) => row.l_p_id,
      sortable: true,
      width: "110px"
    },
    {
      name: "Type",
      wrap: true,
      width: "110px",
      selector: (row) => (
        <Label
          variant="ghost"
          color={row.l_type == 1 ? "warning" : "info"}
          style={{
            marginBottom: "10px",
            display: "flex",
            fontSize: "12px",
            fontWeight: "normal"
          }}
        >
          {row.l_type == 1 ? "LVB Session" : "LVB Podcast"}
        </Label>
      )
    },
    {
      name: "Title",
      wrap: true,
      selector: (row) => (row.l_p_title != "" ? row.l_p_title : "-")
    },
    {
      name: "URL",
      wrap: true,
      selector: (row) => row.l_p_url
    },
    {
      name: "Action",
      wrap: true,
      width: "110px",
      cell: (row) => (
        <>
          <a
            onClick={() => {
              setDvisible({ mval: true, id: row.l_p_id });
            }}
          >
            <Tooltip l_p_title="Delete">
              <IconButton>
                <DeleteSharp color="error" />
              </IconButton>
            </Tooltip>
          </a>
          <a
            onClick={() => {
              setStep(2);
              setgetdata(row);
            }}
          >
            <Tooltip title="Edit">
              <IconButton>
                <EditSharp color="warning" />
              </IconButton>
            </Tooltip>
          </a>
        </>
      )
    }
  ];

  const deleteLvbData = async (l_p_id) => {
    const resp = await deleteLvbsessionPodcast(l_p_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      setresponse(response + 1);
      setDvisible({ mval: false, id: 0 });
    }
  };

  const onChangeFunction = async (e) => {
    setgetdata({
      ...getdata,
      [e.target.name]: e.target.value
    });
  };
  const resetFormData = (e) => {
    setgetdata({
      l_type: 0,
      l_p_title: "",
      l_p_url: ""
    });
  };

  const handleSubmit = async () => {
    let fdata = new FormData();
    fdata.append("l_type", getdata.l_type);
    fdata.append("l_p_title", getdata.l_p_title);
    fdata.append("l_p_url", getdata.l_p_url);

    if (step == 1) {
      if (
        getdata.l_type == "" ||
        getdata.l_type == 0 ||
        getdata.l_p_url == "" ||
        getdata.l_p_url == undefined ||
        getdata.l_p_title == "" ||
        getdata.l_p_title == undefined
      ) {
        let notify = notification({
          type: "error",
          message: "Please Fill Required Fields"
        });
        notify();
      } else {
        setLoading(true);
        const resp = await insertLvbsessionPodcast(fdata);
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
        setStep(0);
        setLoading(false);
        resetFormData();
        setresponse(response + 1);
      }
    } else {
      fdata.append("l_p_id", getdata?.l_p_id);
      if (
        getdata.l_type == "" ||
        getdata.l_type == 0 ||
        getdata.l_p_url == "" ||
        getdata.l_p_url == undefined ||
        getdata.l_p_title == "" ||
        getdata.l_p_title == undefined
      ) {
        let notify = notification({
          type: "error",
          message: "Please Fill Required Fields"
        });
        notify();
      } else {
        setLoading(true);
        const resp = await updateLvbsessionPodcast(fdata);

        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
        setStep(0);
        setLoading(false);
        resetFormData();
        setresponse(response + 1);
      }
    }
  };

  const expo_columns = [
    { label: "No", key: "l_p_id" },
    { label: "Type", key: "lvb_type" },
    { label: "Title", key: "l_p_title" },
    { label: "Link", key: "l_p_url" }
  ];

  return (
    <>
      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={deleteLvbData} />
      <Page l_p_title="LVB Session & Podcast | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              LVB Session & Podcast
            </Typography>
            {step == 0 && (
              <Button
                onClick={() => {
                  setStep(1);
                }}
                style={{ marginBottom: "15px" }}
                variant="contained"
              >
                Add LVB Session & Podcast
              </Button>
            )}
          </Stack>
          {/* Start Category Form */}
          {step != 0 ? (
            <>
              <Button
                onClick={() => {
                  setStep(0);
                  resetFormData();
                }}
                style={{ marginBottom: "15px" }}
                variant="contained"
              >
                Back
              </Button>
              <Card
                style={{
                  padding: "25px",
                  paddingBottom: "25px",
                  marginBottom: "25px"
                }}
              >
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <label>Select Type</label>
                  <RadioGroup
                    style={{ marginTop: "0px" }}
                    row
                    defaultValue={0}
                    value={getdata.l_type}
                    onChange={onChangeFunction}
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="l_type"
                  >
                    <FormControlLabel value="1" control={<Radio />} label="Lvb Session" />
                    <FormControlLabel value="2" control={<Radio />} label="LVB Podcast" />
                  </RadioGroup>
                </Stack>

                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    fullWidth
                    autoComplete="off"
                    value={getdata?.l_p_title ? getdata?.l_p_title : ""}
                    type="text"
                    label="Title"
                    name="l_p_title"
                    onChange={onChangeFunction}
                  />
                </Stack>
                <Stack spacing={3} style={{ marginBottom: "15px" }}>
                  <TextField
                    fullWidth
                    autoComplete="off"
                    value={getdata?.l_p_url ? getdata?.l_p_url : ""}
                    type="text"
                    label="YouTube URL"
                    name="l_p_url"
                    onChange={onChangeFunction}
                  />
                </Stack>
                <Button
                  style={{ marginTop: "15px" }}
                  onClick={handleSubmit}
                  variant="contained"
                  disabled={loading}
                  startIcon={loading && <CircularProgress size={20} color="inherit" />}
                >
                  submit
                </Button>
              </Card>
            </>
          ) : (
            <>
              <Card className="p-20">
                <Grid container spacing={2} sx={{ alignItems: "center" }}>
                  <Grid item xs={4}>
                    <Stack spacing={3} style={{ marginBottom: "15px" }}>
                      <label>Select Type</label>
                      <Select
                        name="lvbStatus"
                        menuPortalTarget={document.body}
                        value={LVBtypeOptions.map((c) => {
                          if (c.value == searchData.lvbStatus) {
                            return { value: c.value, label: c.label };
                          }
                        })}
                        onChange={(e) => {
                          setSearchData({ ...searchData, lvbStatus: e.value });
                        }}
                        options={LVBtypeOptions}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={7}>
                    <Stack spacing={10}>
                      <TextField
                        style={{ marginTop: "0px" }}
                        fullWidth
                        autoComplete="off"
                        type="text"
                        label="Search"
                        name="name"
                        autoCorrect="off"
                        value={searchData?.search ? searchData?.search : ""}
                        onChange={(e) => {
                          setSearchData({
                            ...searchData,
                            search: e.target.value
                          });
                        }}
                      />
                    </Stack>
                  </Grid>
                  <Grid
                    item
                    xs={1}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end"
                    }}
                  >
                    <Button onClick={ClearSearchResult} variant="contained">
                      clear
                    </Button>
                  </Grid>
                </Grid>
              </Card>
              <Card className="p-20" sx={{ mt: 2 }}>
                {lvbsessionPodcastList && (
                  <>
                    <Button className="btn btn-export">
                      <CSVLink
                        data={sessionPodcastData}
                        headers={expo_columns}
                        filename={"LVB Session & Podcast List.csv"}
                        className="btn btn-primary test"
                        target="_blank"
                      >
                        Export CSV
                      </CSVLink>
                    </Button>
                    <DataTable
                      filter
                      pagination
                      highlightOnHover
                      columns={columns}
                      data={sessionPodcastData != null && sessionPodcastData}
                      progressPending={loading}
                      progressComponent={<CustomLoader />}
                    />
                  </>
                )}
              </Card>
            </>
          )}
        </Container>
      </Page>
    </>
  );
}
